import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Home = () => {
  const handleDownloadCV = () => {
    // Replace 'your-cv-filename.pdf' with the actual filename of your CV
    const cvUrl = '/resume.pdf';
    const link = document.createElement('a');
    link.href = cvUrl;
    link.setAttribute('download', 'resume.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className=" w-screen overflow-hidden" id={'home'}>
      <div className="Home mx-auto flex flex-col lg:flex-row items-center gap-[20px] lg:justify-between   lg:w-[70%] h-[90vh]">
        <motion.div
          className=" flex flex-col"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{
            delay: 0.1,
            x: { type: 'spring', stiffness: 100 },
            opacity: { duration: 0.8 },
            ease: 'easeIn',
            duration: 1,
          }}
        >
          <div className=" flex flex-row gap-8 items-center">
            <div className="flex-col flex  gap-20 ">
              <a
                href="https://www.linkedin.com/in/okoi-david-6a01142a0/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedinIn size={40} />
              </a>
              <a
                href="https://www.instagram.com/king_dave_offical/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram size={40} />
              </a>
              <a
                href="https://web.facebook.com/agba.coder"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook size={40} />
              </a>
            </div>
            <div>
              <h2 className=" text-[30px] font-extrabold ">
                Hey, <span className=" text-yellow-500"> I'm </span>{' '}
              </h2>
              <h1 className=" text-[50px] font-bold ">
                Okoi <br /> David James
              </h1>
              <p className="tay">
                <TypeAnimation
                  sequence={[
                    'A MERN-STACK Developer🤖',
                    1000,
                    'A Full-Stack Developer💻',
                    1000,
                    'JavaScript Developer🤐',
                    1000,
                  ]}
                  wrapper="span"
                  speed={50}
                  style={{ fontSize: '2em', display: 'inline-block' }}
                  repeat={Infinity}
                />
              </p>
              <div className="flex gap-4 pt-6">
                <button
                  className="btn btn-outline btn-warning hover:text-white"
                  onClick={handleDownloadCV}
                >
                  Download CV
                </button>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
          className=" lg:w-[340px] lg:h-[340px] w-[280px] h-[280px] border border-accentClr dark:border-accentClrDark bg-center bg-cover rounded-full"
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{
            delay: 0.1,
            x: { type: 'spring', stiffness: 100 },
            opacity: { duration: 0.8 },
            ease: 'easeIn',
            duration: 1,
          }}
          style={{
            backgroundImage: `url("/okoi d.jpg")`,
          }}
        ></motion.div>
      </div>
    </div>
  );
};

export default Home;
